import { render } from "./App.vue?vue&type=template&id=4bf903d8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4bf903d8&lang=css"

import exportComponent from "E:\\xiangqukejidaima\\米优时官网\\miyoushi-web (3)\\miyoushi-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__